import React from "react"
import { ResultRowShell } from "./result_row_shell"
import { CategoryIcon } from "../category_icon"
import type { SearchRowComponent } from "./types"
import Title from "@love-irish/core-title"

// A collection result: a folder glyph and the collection name.
export const CollectionRow: SearchRowComponent = ({
  hit,
  position,
  onSelect,
}) => (
  <ResultRowShell hit={hit} position={position} onSelect={onSelect}>
    <CategoryIcon
      category="Collections"
      className="shrink-0 text-secondary-400"
    />
    <Title
      size="xs"
      className="truncate font-sans! text-sm"
      variant="plain"
      title={hit.name}
    />
  </ResultRowShell>
)
